import React from 'react';
import i18n from 'i18next';


const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
};

function isActive(lang){
    const currentLanguage = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
    if(currentLanguage === lang){
        return 'active';
	}else{
    	return '';
	}
}

function LanguageSwitcher({t}) {
	return (
		<div className="languageWrapper">
			<p className={`languageItem ${isActive("en")}`} onClick={() => changeLanguage('en')}>EN</p>
			<p className={`languageItem ${isActive("de")}`} onClick={() => changeLanguage('de')}>DE</p>
		</div>
	);
}

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./src/overview/LanguageSwitcher.js